// The canvas takes every wheel event to pan, so nothing scrollable that lives
// on it would scroll. An element marked with this attribute keeps the wheel to
// itself — an open thread scrolls its comments and its reply under the pointer
// instead of moving the canvas away. A pinch or Cmd+wheel still zooms the
// canvas.
const OWN_WHEEL_SELECTOR = '[data-own-wheel]'

export const isInsideOwnWheel = (target: EventTarget | null): boolean =>
  target instanceof Element && target.closest(OWN_WHEEL_SELECTOR) !== null
